import React from "react";
import ReactDOM from "react-dom"
import useScript from '../../../hooks/useScript';

const PayPal = ({ createOrder, onApprove }) => {
  const status = useScript(
    `https://www.paypal.com/sdk/js?client-id=${process.env.PAYPAL_CLIENT_ID}&disable-funding=card,credit,bancontact&commit=false`)
  ;

  const PayPalButton = window.paypal && window.paypal.Buttons.driver("react", { React, ReactDOM });

  return (
    <div>
      {status === "ready" && (
        <PayPalButton
          createOrder={(data, actions) => createOrder(data, actions)}
          onApprove={(data, actions) => onApprove(data, actions)}
        />

      )}
    </div>
  );
}

export default PayPal;
